import React from "react";
import { Row, Col } from "antd";
import { useDashboard } from "providers/DashboardProvider";
import UserGrowthAudienceCard from "./user-growth/UserGrowthAudienceCard";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";

const Analytics = () => {
  const {
    userGrowthRanges,
    userGrowthRangesCustomers,
    userGrowthRangesStaff,
    userGrowthRangesUnclassified,
    totalOrderTotalLabel,
    usersForAnalytics,
    usersCustomersForAnalytics,
    usersStaffForAnalytics,
    usersUnclassifiedForAnalytics,
  } = useDashboard();

  return (
    <>
      <WidgetSectionTitle
        icon="chart-line"
        title="Analytics"
        subtitle="User growth and activity insights"
        transform="shrink-2"
        className="mb-3 mt-3 fw-normal"
      />

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <UserGrowthAudienceCard
            growthRanges={userGrowthRanges}
            growthRangesCustomers={userGrowthRangesCustomers}
            growthRangesStaff={userGrowthRangesStaff}
            growthRangesUnclassified={userGrowthRangesUnclassified}
            totalUsersLabel={totalOrderTotalLabel}
            users={usersForAnalytics}
            usersCustomers={usersCustomersForAnalytics}
            usersStaff={usersStaffForAnalytics}
            usersUnclassified={usersUnclassifiedForAnalytics}
          />
        </Col>
      </Row>
    </>
  );
};

Analytics.propTypes = {};

export default Analytics;
